import { string } from 'prop-types';
import React from 'react';
import { loadClickAnalyticsActions } from '@coveo/headless';
import { relinfos_engine } from '../../controllers/searchresultscontroller';
import { useAnalyticsContext } from '../../../../config/GoogleTagManagerEvents';
import PlayCircleWhite from '../../../../resources/images/play-circle-white.svg';
import './searchresultItemcard.scss';
import { VARIABLE_CONFIG } from '../../../../constants/analyticsConstants/Variables';
import { logError } from '../../../global/utils/logger';

const SearchResultCommon = props => {
    const { label, title, content } = props;
    return (
        <>
            <div className="searchresultcard__label">{label}</div>
            <h5 className="searchresultcard__title">{title}</h5>
            <div className="">{content}</div>
        </>
    );
};

const RenderVideo = props => {
    const { mediaSrc, title, imageSrc } = props;
    return (
        <>
            <div className="searchresultcard__rightwrap">
                <div className="searchresultcard__iconwrap">
                    <PlayCircleWhite />
                </div>
                <img alt={title} src={imageSrc} className="searchresultcard__media" />
            </div>
        </>
    );
};
const RenderImage = props => {
    const { mediaSrc, altText } = props;
    return <img src={mediaSrc} className="searchresultcard__media" alt={altText} />;
};

const SearchResultItemVideoCard = props => {
    const { label, title, content, mediaType, mediaSrc, imageSrc } = props;
    const getMediaType = {
        video: <RenderVideo mediaSrc={mediaSrc} title={title} imageSrc={imageSrc} />,
        image: <RenderImage mediaSrc={mediaSrc} altText={title} />
    };
    return (
        <>
            <div className="searchresultcard__left">
                <SearchResultCommon label={label} content={content} title={title} />
            </div>
            <div className="searchresultcard__right">{getMediaType[mediaType]}</div>
        </>
    );
};

const SearchResultItemCard = props => {
    const { label, title, content, videoSrc, mediaType, mediaSrc, clickUri, item } = props;
    const { sendEventsForClick }  = useAnalyticsContext();
    const handleCardClick = () => {
        try {
            sendEventsForClick(
                VARIABLE_CONFIG.EVENT.UAEVENT,
                VARIABLE_CONFIG.ECOMMERCE.UNDEFINED,
                VARIABLE_CONFIG.EVENT_CATEGORY.SEARCH,
                VARIABLE_CONFIG.EVENT_ACTION.SEARCH_RELATED_INFO,
                title
            );
            sendDataToCoveo(item);
        } catch (error) {
            logError(error ,false,'handleCardClick');
        }
        window.location.href = clickUri;
    };

    const sendDataToCoveo = (item) => {
        const action = loadClickAnalyticsActions(relinfos_engine).logDocumentOpen(item);
        relinfos_engine?.dispatch(action);
    }

    return (
        <div
            className={`searchresultcard ${mediaType || mediaSrc ? 'searchresultcardvideo' : ''}`}
            onClick={handleCardClick}
            tabIndex={'0'}
            >
            {mediaType || mediaSrc ? (
                <SearchResultItemVideoCard
                    label={label}
                    title={title}
                    content={title}
                    videoSrc={videoSrc}
                    mediaType={mediaType}
                    mediaSrc={mediaSrc}
                />
            ) : (
                <SearchResultCommon label={label} content={content} title={title} />
            )}
        </div>
    );
};

SearchResultItemCard.propsType = {
    videoSrc: string,
    label: string,
    title: string,
    content: string
};

SearchResultItemCard.defaultProps = {
    videoSrc: '',
    label: '',
    title: '',
    content: ''
};
export default SearchResultItemCard;
